// Fase V5 of the Vynko expansion plan -- a pure function, no DOM access,
// so it's testable with literal strings and safe to call from both real
// components (window.location) and tests. Implements plan decisions D1/D2:
// branding is decided by ROUTE for product surfaces (chips already
// fabricated keep resolving the same way forever, regardless of which
// domain serves the page) and by HOST for everything else (marketing).
//
// Dormant as of this commit: nothing imports this module yet. It exists
// so the resolver itself can be built and tested independently of the
// domain existing -- vynko.cards/getvynko.com aren't registered yet (see
// the plan's V0 owner-blocked prerequisites).

// Closed, exact allowlist -- NEVER a substring/suffix match. A substring
// check (hostname.includes("vynko")) would let a lookalike host
// ("vynko.cards.evil.example") or a spoofed Host header force the Vynko
// brand; matching only these exact strings closes that off entirely.
const VYNKO_HOSTS = new Set(["vynko.cards", "www.vynko.cards", "getvynko.com", "www.getvynko.com"]);

// Product-surface route prefixes -- ALWAYS Vynko, independent of host.
// This is what keeps a chip fabricated before the domain cutover working
// forever: it's baked with https://revosdirector.com/c/{slug}, and that
// tap must render the Vynko brand on the OLD domain, not redirect or
// silently look like RevOSDirector's own corporate site.
// The product, audience and use-case pages (and their Spanish mirrors) are linked from the catalog
// gallery, which is also served on this domain, so they must keep the Vynko brand here too.
const PRODUCT_ROUTE_PREFIXES = [
  "/c/", "/p/", "/pay/", "/loyalty/", "/offer/", "/my-cards", "/tap",
  "/products/", "/for/", "/use/", "/es/tarjetas-nfc", "/es/products/", "/es/for/", "/es/use/",
];

export function resolveBrand(hostname, pathname) {
  const host = (hostname || "").toLowerCase();
  const path = pathname || "/";
  const isProductRoute = PRODUCT_ROUTE_PREFIXES.some((prefix) => path.startsWith(prefix));
  if (isProductRoute || VYNKO_HOSTS.has(host)) {
    return "vynko";
  }
  return "revosdirector";
}

// Host-only check (no path/product-route override), for call sites that
// need to know which ORIGIN is actually serving the page -- API base URL
// selection, in particular. A printed chip's /c/{slug} page always RENDERS
// as Vynko-branded (see resolveBrand() above and plan decision D2), but
// when that page happens to be served from revosdirector.com it must still
// call api.revosdirector.com, not api.getvynko.com -- both domains proxy
// to their OWN backend container per plan decision D1/D3 (one build,
// branding resolved in the UI layer only), so the API call always follows
// the real serving host, never the visual brand. Exported so apiBase.js
// (and anything else that needs "which host am I actually on") reuses this
// exact allowlist instead of duplicating VYNKO_HOSTS a second time.
export function isVynkoHost(hostname) {
  return VYNKO_HOSTS.has((hostname || "").toLowerCase());
}
